export class QHoverMsg {
  constructor() {
    this.fShortText = null;
    this.fLongText = null;
    this.fShortCutText = null;
    this.fCustomMsg = false;
    this.fLargeMsg = false;
  }

  InitMsg(rawMsg, shortcut) {
    if (rawMsg == null) rawMsg = "<not set>";
    var s = rawMsg.split("^");
    this.fShortText = s[0];
    if (this.fShortText.length > 0 && this.fShortText[0] == "!") {
      this.fShortText = this.fShortText.substring(1);
      this.fCustomMsg = true;
      if (this.fShortText[0] == "!") {
        this.fLargeMsg = true;
        this.fShortText = this.fShortText.substring(1);
      }
    }

    if (s.length > 1) this.fLongText = s[1];

    if (shortcut != null && shortcut.length > 0) this.fShortCutText = shortcut;
  }

  IsCustomMsg() {
    return this.fCustomMsg;
  }

  IsBlank() {
    if (this.fShortText == null || this.fShortText.length == 0) return true;
    return false;
  }
}
